module.exports = __webpack_public_path__ + "static/media/hakon-wium-le.b6f8844c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/hakon-wium-le.png
// module id = 244
// module chunks = 0